'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaVine = function FaVine(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.4 18.5v4.4q-2.2 0.5-4.4 0.5-1.5 3-3.7 6t-4 4.9-2.9 2.3q-1.8 1-3.6 0-0.6-0.4-1.4-1t-1.9-1.9-2.3-2.8-2.4-4.1-2.3-5.5-2.1-7-1.5-8.7h6.3q0.6 4.8 1.6 8.9t2.3 7.1 2.7 5.2 3.1 4.4q3.8-3.8 6.4-9.1-3.1-1.6-4.9-4.9t-1.9-7.4q0-4.3 2.4-7.1t6.3-2.7q4 0 6.1 2.4t2.1 6.6q0 3.5-1.3 6.4-0.1 0-0.4 0t-1 0.1-1.4-0.1-1.4-0.6-1.2-1.2q0.7-2.3 0.7-4.1 0-1.9-0.6-2.9t-1.8-1q-1.2 0-1.9 1.1t-0.7 3.1q0 4.2 2.4 6.6t5.9 2.4q1.4 0 2.7-0.3z' })
        )
    );
};

exports.default = FaVine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/vine.js
// module id = 2077
// module chunks = 168707334958949